export default __webpack_public_path__ + "static/media/announce.f827d2b6.svg";